module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-192x192.d37209810bb0b4021a160d663a2cf1b7.png";